import { Box, Button, Divider, Drawer, Stack, Typography } from "@mui/material";
import { useTheme } from '@mui/material/styles';
import { LeftSideBarTabs, RightSideBarTabs } from "../utils/sidebar";
import Iconify from "./Iconify";
import CustomIcon from "./customIcon";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useContext, useEffect, useState } from "react";
import { LoginContext, ToastContext } from "../context/context";
import { clearUser } from "../redux/reducers/user";
import betServices from "../services/betServices";
import eventServices from "../services/eventServices";
import authServices from "../services/authServices";
import userSocket from "../services/userSocket";
import { changeOneClickStatus, clearStake } from "../redux/reducers/stakes";
import accountServices from "../services/accountServices";
import { userDisconnected } from "../redux/reducers/socket";
import { getLogoLink } from "../utils/functions";


export default function Header({openLeftNav,setOpenLeftNav,openRightNav,setOpenRightNav})
{
    const { isLogginIn,balanceData } = useSelector(state=>state.user);
    const { user_socket } = useSelector(state=>state.sockets);
    const [showSearch,setShowSearch] = useState(false);
    // const [balanceData,setBalanceData] = useState();
    const {setOpenLogin} = useContext(LoginContext);
    const {setShowToast} = useContext(ToastContext);
    const [logoLink,setlogoLink] = useState('');
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const {pathname} = useLocation();
    const showMenu = [
        {
            path:"/sport",
            showMenu:true,
        },
        {
            path:"/racing",
            showMenu:true,
        },
        {
            path:"/my-markets",
            showMenu:true,
        },
    ]

    useEffect(()=>{
        
        if(user_socket.isConnected){
            // userSocket.connect();
            // userSocket.getBalanceData(setBalanceData);
            userSocket.logoutUser(handleLogout);
            userSocket.userError(handleLogout);
            userSocket.getExposureAndOpenBets(handleBetsChanges);
            // userSocket.joinUser();
            // setTimeout(()=>{
            //     // getBalance();
            // },2000)
        }
    },[user_socket.isConnected])

    const handleBetsChanges = () =>{
        setShowToast(
            {
                error:false,
                message:"",
                bet:true
            }
        )
    }

    useEffect(()=>{
        console.log(pathname);
    },[pathname])
    useEffect(()=>{
        getLogo();
    },[])

    const getLogo = async() =>{
        try {
            setlogoLink(await getLogoLink())
        } catch (error) {   
            console.log(error)
        }
    }

    // const getBalance = async() =>{
    //     const res = await authServices.getBalance();
    //     if(res)
    //     {
    //         setBalanceData({...res});
    //     }

    // }

    const handleLogout = () =>{
        dispatch(clearUser());
        dispatch(clearStake());
        dispatch(userDisconnected());
        userSocket.disconnect();
        navigate("",{replace:true})
        window.location.reload();
    }

    return(
        <Box sx={{ bgcolor:"var(--primary)"}} className={`${pathname.includes("game-details") ? "":"sticky-top"}`} >
            <NotificationContainer />
            <Box className={`app-panel ${!showSearch?"visible":""}`} sx={{ height:60,display:'flex' }} justifyContent={"space-between"}>
                <Box sx={{display:'flex'}}>
                     
                        <LeftSideBar openLeftNav={openLeftNav} setOpenLeftNav={setOpenLeftNav}/>
                        
                        {
                            showMenu.find((p)=>pathname.includes(p.path) && p.showMenu && !pathname.includes("game-details")) || pathname == "/" ? 
                            <Box className="pointer" sx={{padding:"16px 16px",color:'#fff',margin:0,alignSelf:'center'}} onClick={()=>setOpenLeftNav(true)}>
                            <CustomIcon className={"menuicon"}  name={"menuicon"} color={"#fff"} />
                        </Box>
                            :
                            <Box className="pointer" sx={{padding:"16px 16px",color:'#fff',margin:0}} onClick={()=>navigate(-1)}>
                                <CustomIcon className={"back-arrow"}  name={"back-arrow"} color={"#fff"} />
                            </Box>
                        }
                    
                    <RightSideBar className="pointer" balanceData={balanceData} openRightNav={openRightNav} setOpenRightNav={setOpenRightNav}/>
                    <Box className="pointer" marginLeft={"10px"} width={"120px"} paddingY={2} onClick={()=>navigate("")}>
                        {logoLink && <img src={logoLink} alt="" height={"100%"} width={"100%"}/>}
                    </Box>
                </Box>
                <Box sx={{display:'flex'}} alignItems={"center"} padding={1}  >
                    <Box 
                        onClick={()=>setShowSearch(true)}
                        className="pointer"
                        sx={{
                            fontSize: '20px',
                            width: '36px',
                            height: '36px',
                            marginLeft: 'var(--sPad)',
                            marginRight: 'var(--sPad)',
                            color: 'var(--header-button-color)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}>
                        <CustomIcon name={"search"} color={"#fff"} fontSize={"20px"}/>
                    </Box>
                {
                    isLogginIn?
                <Box className="pointer" bgcolor={"var(--header-right-button-menu-bg-color)"} color={'var(--header-right-button-signup-color)'} height={40} width={70} ml={2} alignItems={"center"} display={"flex"} flexDirection={"column"} onClick={()=>setOpenRightNav(true)}>
                        <CustomIcon name={"user"} fontSize={"14px"} />
                        <Typography  lineHeight={1} fontSize={"12px"}>{Math.trunc(balanceData?.available_credit)}</Typography>
                    </Box> 
                    :
                    <Button onClick={()=>setOpenLogin(true)}
                    sx={{
                        fontSize:12,
                        padding:"0 10px",
                        backgroundColor: 'var(--header-right-button-menu-bg-color)',
                        color: 'var(--header-right-button-signup-color)',
                        border: '1px solid var(--header-right-button-menu-bg-color)',
                        fontWeight:"400",
                        minWidth:"auto"
                    }}>Login</Button>
                }
                </Box>
            </Box>
           <SearchBar show={showSearch} setShow={setShowSearch} />
           <OneClickSetting />
        </Box>
    )
}

const LeftSideBar = ({openLeftNav,setOpenLeftNav})=>{
    const navigate = useNavigate()
    const theme = useTheme();
    const { isLogginIn } = useSelector(state=>state.user);
    const { menu } = useSelector(state=>state.sports);


    const renderMenuItem = (info) =>{

        let link = info.link

        if(!info.link){
            if(info.type==="Casino") link = `/live-casino/${info.provider_id}`
            else if(info.type==="Sport"){
                if(info.provider_id === "7" || info.provider_id === "4339"){
                    link = `/racing/${info.provider_id}`
                }
                else{
                    link = `/sport/${info.provider_id}`
                }
            }
        }

        return(
            <>
                <Stack className="pointer" direction={"row"} alignItems={"center"} spacing={1} sx={{padding:"8px 0px"}} onClick={()=>{navigate(link);setOpenLeftNav(false)}}>
                    <CustomIcon className={'lm-'+info?.icon} name={info?.icon} minWidth={'32px'} fontSize={20}/>
                    <Stack direction={"row"} alignItems={"center"} spacing={1}>
                    <Typography sx={{textTransform:"capitalize",fontWeight:"700"}} >{info?.menu_name} </Typography>
                    {
                        info.is_new &&
                    <span className="new-label">New</span>
                    }
                    </Stack>
                </Stack>
                <Divider/>
            </>
        )
    }

    return(
        <>
            <Drawer
                SlideProps={{
                    easing:"cubic-bezier(0, 0, 0.2, 1)",
                    timeout:300,
                }}
                sx={{
                width: 260,
                flexShrink: 0,
                '& .MuiDrawer-paper': {
                    width: 260,
                    boxSizing: 'border-box',
                },
                }}
                onClose={()=>setOpenLeftNav(false)}
                open={openLeftNav}
            >
                <Box className="pointer" sx={{marginBottom:"80px",padding:"0px 16px", marginTop:"15px"}}>
                    <>
                            <Stack direction={"row"} alignItems={"center"} spacing={1} sx={{padding:"8px 0px"}} onClick={()=>{navigate("");setOpenLeftNav(false)}}>
                                <CustomIcon className={"lm-home"} name={"home"} fontSize={20} minWidth={"32px"}/>
                                <Typography sx={{fontWeight:"700 !important"}}>{"Home"}</Typography>
                            </Stack>
                            <Divider/>
                        </>
                    {
                        isLogginIn && (
                        <>
                            <Stack direction={"row"} alignItems={"center"} spacing={1} sx={{padding:"8px 0px"}} onClick={()=>{navigate("/my-markets");setOpenLeftNav(false)}}>
                                <CustomIcon className={"lm-mymarkets"} name={"mymarkets"} fontSize={20} minWidth={"32px"}/>
                                <Typography sx={{fontWeight:"700 !important"}} >{"My Markets"}</Typography>
                            </Stack>
                            <Divider/>
                        </>
                        )
                    }
                {menu?.map((info, index) => renderMenuItem(info))}
                {/* {LeftSideBarTabs.filter((i)=>isLogginIn || (!isLogginIn && !i.checkLogin)).map((info, index) => (
                    <>
                        <Stack direction={"row"} alignItems={"center"} spacing={1} sx={{padding:"8px 0px"}} onClick={()=>{navigate(info?.link);setOpenLeftNav(false)}}>
                        <CustomIcon className={'lm-'+info?.icon} name={info?.icon} minWidth={'32px'} fontSize={20}/>
                            <Typography sx={{textTransform:"capitalize",fontWeight:"700"}} >{info?.name} </Typography>
                    {
                        info.is_new &&
                    <span className="new-label">New</span>
                    }
                        </Stack>
                        <Divider/>
                    </>

                ))} */}
                </Box>
            </Drawer>
        </>
        
    )
}
const RightSideBar = ({openRightNav,setOpenRightNav,balanceData})=>{
    const navigate = useNavigate()
    const { user } = useSelector(state=>state.user);
    const dispatch = useDispatch();


    const handleClick = (info) =>{
        console.log("info..........................", info)
        if(info.link) navigate(info.link);
        if(info.name === "Signout")
        {
            handleLogout();
        }
        setOpenRightNav(false)
    }

    const handleLogout = () =>{
        dispatch(clearUser());
        dispatch(clearStake());
        dispatch(userDisconnected());
        userSocket.disconnect();
        navigate("",{replace:true})
        window.location.reload();
    }

    return(
        <>
            <Drawer
                SlideProps={{
                    easing:"cubic-bezier(0, 0, 0.2, 1)",
                    timeout:300,
                }}
                sx={{
                width: 260,
                flexShrink: 0,
                '& .MuiDrawer-paper': {
                    width: 260,
                    boxSizing: 'border-box',
                },
                }}
                onClose={()=>setOpenRightNav(false)}
                anchor="right"
                open={openRightNav}
            >
                <Box sx={{padding:"0px 16px",paddingBottom:"0px"}}>
                    <Box sx={{padding:"16px 0px",textAlign:"center",fontWeight:700,fontSize:'20px'}}>
                        {user?.user_name}
                    </Box>
                    <Divider/>
                    <Box>
                        <Stack sx={{alignItems:'center',fontWeight:700,margin:"10px 5px",height:'fit-content'}} direction={"row"} spacing={2}>
                            <Iconify color={"#000"} fontSize={"20px"} icon={"mdi:bank"} />
                            <Typography sx={{marginLeft:"10px !important"}} color={"#000"} fontWeight={700}>Balance Information</Typography>
                        </Stack>
                        <Stack direction={"column"} spacing={2}>
                            <Stack justifyContent={"space-between"} sx={{marginTop:"10px !important"}} fontSize={"14px"} direction={"row"}>
                                <Typography variant="body3" fontSize={"14px"} color={"#000"}>Available Credit:</Typography>
                                <Typography variant="body3" color={"#000"} fontWeight={"bolder"}>{Math.trunc(balanceData?.available_credit)}</Typography>
                            </Stack>
                            <Stack justifyContent={"space-between"} sx={{marginTop:"10px !important"}} fontSize={"14px"} direction={"row"}>
                                <Typography variant="body3" fontSize={"14px"} color={"#000"}>Credit Limit:</Typography>
                                <Typography variant="body3" color={"#000"}>{Math.trunc(balanceData?.credit_limit)}</Typography>
                            </Stack>
                            <Stack justifyContent={"space-between"} sx={{marginTop:"10px !important"}} fontSize={"14px"} direction={"row"}>
                                <Typography variant="body3" fontSize={"14px"} color={"#000"}>Winnings:</Typography>
                                <Typography variant="body3" className={`${Math.trunc(balanceData?.winnings)>=0?"positive":"negative"}`} >{Math.trunc(balanceData?.winnings) ? Math.trunc(balanceData?.winnings) : ""}</Typography>
                            </Stack>
                            <Stack justifyContent={"space-between"}  sx={{marginTop:"10px !important"}} direction={"row"} marginBottom={"16px !important"}>
                                <Typography variant="body3" fontSize={"14px"} color={"#000"}>Net Exposure:</Typography>
                                <Typography variant="body3" className="negative" >{Math.trunc(balanceData?.total_net_exposure)}</Typography>
                            </Stack>
                        </Stack>
                    </Box>
                    <Divider/>
                    {/* <Stack sx={{alignItems:'center',fontWeight:700,margin:"8px 0",height:'fit-content'}} direction={"row"} spacing={2} onClick={()=>{navigate("settings");setOpenRightNav(false)}}>
                           
                            <CustomIcon name={"setting"} sx={{width:"25px"}} fontSize={"14px"} />
                            <Typography color={"var(--primary)"} marginLeft={"8px !important"} fontWeight={700} fontSize={"14px"}>Settings</Typography>
                    </Stack>
                    <Divider/> */}
                    {RightSideBarTabs?.map((info, index) => (
                    <>
                        <Stack direction={"row"} alignItems={"center"} color={"#000"} spacing={1} sx={{padding:"10px 0px"}} className="pointer" onClick={()=>handleClick(info)}>
                            <CustomIcon name={info?.icon} color={"#000"} sx={{width:"25px"}} fontSize={"14px"}/>
                            <Typography fontWeight={700} fontSize={"16px"} color={"#000"}>{info?.name}</Typography>
                        </Stack>
                        <Divider/>
                    </>

                    ))}
                    {/* <TestBanner/> */}
                </Box>
            </Drawer>
        </>
        
    )
}


const TestBanner = ()=>{
    return(
        <Box className={"user-test-banner"}>
            <Box className={"container"}>
                <div class="text-container">
                    <h6 class="section-title" style={{paddingBottom:0,lineHeight:1.15}}>
                        Do you watch sport video streams?
                    </h6>
                    <p class="section-description" style={{paddingLeft:"8px"}}>
                        Share your experience with us
                    </p>
                </div>
                <Box className={"share"}>Share</Box>
            </Box>
        </Box>
    )
}

const SearchBar = ({show,setShow})=>{
    const [query,setQuery] = useState("");
    const [results,setResults] = useState([]);
    const {sports} = useSelector(state => state.sports);
    const navigate = useNavigate();

    useEffect(()=>{
        if(!show)
        {
            setQuery("");
            setResults([]);
        }
    },[show])


    useEffect(()=>{
        if(query && query.length > 2)
        {
            searchEvent();
        }
        else{
            setResults([]);
        }
    },[query])

    async function searchEvent()
    {
        const res = await eventServices.searchEventByName(query);
        if(res && res.length > 0)
        {
            setResults(res);
        }
        else{
            setResults([]);
        }
    }

    const handleClick= (event) =>{
        console.log(event);
        if(sports && sports.length>0)
        {
            const sport = sports.find((_sport)=>_sport.game_id === event.game_id);
            setShow(false);
            navigate(`/sport/${sport.game_name}/game-details/${event?event.provider_event_id:37373737}`,{state:event})
        }
    }

    return(
        <>
         <Box className={`app-panel search-panel ${show?"visible":""}`}>
                <input value={query} onChange={(e)=>setQuery(e.target.value)} type="text" className="search-term " placeholder="Search Events" />
                <Button className="button" onClick={()=>setShow(false)}>
                    <CustomIcon name={"modal-close"} />
                </Button>
            </Box>
            <Box className={`search-result ${show?"visible":""}`}>
                <Box className={`app-list`}>
                    {
                        query && query.length > 2 ?
                        results.length>0?
                        results?.map((result)=>{
                            return(
                            <Box className={`app-list-item`} onClick={()=>handleClick(result)}>
                                <Box className={"search-event-title"}>{result.event_name}</Box>
                            </Box>
                            )
                        })
                        :
                        <Box className={`app-list-item`}>
                            <Box className={"search-event-title"}> No events found matching '{query}' </Box>
                        </Box>
                        :""
                    }
                </Box>
            </Box>
        </>
    )
}

const OneClickSetting = () =>{
    const { is_one_click_bet_enable,active_one_click_stake } = useSelector(state => state.stake);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const {pathname} = useLocation();

    const handleSwitchOnclick = (e) =>{
        e.preventDefault();
        e.stopPropagation();
        dispatch(changeOneClickStatus());
    }

    return(
        <>
        {
            is_one_click_bet_enable && !(pathname === "/settings") &&
            <Box sx={{
                background:"var(--negative)",
                color:"var(--white)",
                position: 'relative',
                textAlign: 'center',
                padding: 'var(--mPad) 0',
                fontSize: '10px',
                textDecoration: 'underline'
            }}
                onClick={()=>navigate("/settings")}
            >
                1 CLICK BET IS ON - ACTIVE STAKE {active_one_click_stake} 
                <Box 
                className={"-warning"}
                sx={{
                    display: 'block',
                    position: 'absolute',
                    left: 'var(--mPad)',
                    top: '50%',
                    transform: 'translateY(-50%)'
                }}>

                    <Box sx={{height:'24px',display:'inline-block'}}>
                        <Box  onClick={handleSwitchOnclick} className={`toggle-container ${true ? "on" :"off"}`}>
                            <Box className={"toggle-button"}></Box>
                        </Box>
                    </Box>
                </Box>
            </Box>
        }
        </>
    )
}

const NotificationContainer = () =>{
    const { isLogginIn,user } = useSelector(state=>state.user);
    const [msg,setMsg] = useState();
    const [showMsg,setShowMsg] = useState(true);
    useEffect(()=>{
        if(isLogginIn)
        {
            getNotification();
        }
    },[isLogginIn])

    const getNotification =  async() =>{
        try {
            const res = await accountServices.getNotification(user.user_id)
            if(res && res.notification)
            {
                setMsg(res.notification);
                console.log(res.notification,res.notification.length)
            }
        } catch (error) {
            
        }
    }
    if(msg && showMsg && isLogginIn)
    {
        return(
            <Box
                sx={{
                    display: 'flex',
                    padding: '10px 0',
                    color: 'var(--notifications-container-color)',
                    background: 'var(--notifications-container-bg-color)',
                    position: 'relative',
                    lineHeight:1.15
                }}
            
            >
                <Box
                    sx={{
                        display: 'inline-block',
                        position: 'relative',
                        flexGrow: '1',
                        overflow: 'hidden',
                        whiteSpace: 'nowrap'
                    }}
                >
                    <Box
                        sx={{
                            display: 'inline-block',
                            wordBreak: 'keep-all',
                            whiteSpace: 'nowrap',
                            paddingLeft: '100%',
                            willChange: 'transform',
                            animationName:"marquee",
                            // animationDuration:`${msg?.length * 200}ms`,
                            animationDuration:`15000ms`,
                            animationIterationCount:"infinite",
                            animationTimingFunction:"linear",
                            fontSize:14,
                            "@keyframes marquee":{
                                "0%":{
                                    transform:"translateZ(0)"
                                },
                                "100%":{
                                    transform:"translate3d(-100%,0,0)"
                                }
                            }
                        }}
                    >
                        {msg}
                    </Box>
                </Box>
                <Box
                    onClick={()=>setShowMsg(false)}
                    sx={{
                        padding: '0 15px',
                        display: 'inline-block',
                        textDecoration: 'none',
                        color: 'var(--notifications-container-close-btn-color)'
                    }}
                >
                    <span _ngcontent-ijr-c86=""> x </span>
                </Box>
            </Box>
        )
    }
    return <></>;
}